import Header from "../../../components/Header";

let ErrorsMixin = {
    mixins: [],
    components: {
        Header,
    },
    data() {
        return {
            error: '',
            login: '/login',
            devMode: false,
        };
    },
    methods: {
        errorHandle(err, withRedirect = false, withNotice = false, title = 'Error') {
            if (!err) {
                return '';
            }
            if (err.response) {
                if (err.response.status === 401 && withRedirect) {
                    this.$router.push({path: this.login});
                    return '';
                }
                if (err.response.statusText) {
                    if (this.devMode) {
                        this.error = ` [${err.response.status} ${err.response.statusText}]`;
                    }
                } else {
                    if (this.devMode) {
                        this.error = `[${err.response.status}]`;
                    }
                }
                if (err.response.status >= 500) {
                    this.error = ` Invalid api response [status: ${err.response.status }]`
                }
                console.log(err.response);
                if (err.response.data !== '') {
                    if (err.response.data.error !== undefined) {
                        if (err.response.data.error.msg !== undefined) {
                            this.error += err.response.data.error.msg;
                        } else {
                            this.error += err.response.data.error;
                        }
                    } else {
                        if (err.response.headers["content-type"] !== "text/html" &&
                            err.response.headers["content-type"] !== "text/plain") {
                            this.error += err.response.data;
                        }
                    }
                }
            } else if (err !== "") {
                this.error = err;
            } else {
                this.error = 'Server error:  no connection'
            }
            if (withNotice && this.error !== '') {
                this.$bvToast.toast(this.error, {
                    title: title,
                    autoHideDelay: 5000,
                    variant: 'danger',
                    appendToast: true
                });
            }
            return this.error;
        },
    },
    computed: {
        isDataVisible() {
            if (this.loading === 'loading') {
                return false;
            } else {
                return true;
            }
        },

    },
    watch: {},
    created: function () {
        this.pagePreview = this.$route.path
    },
    destroyed() {
        clearInterval(this.cashInterval)
    },
    mounted() {
        // this.startSSE()
    },
    updated: function () {
        window.cacherThis = this;
    }
};

export {ErrorsMixin};